// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editNoteContent {
  display: grid;
  gap: 1rem;
}
.editNoteContent ::ng-deep .wid100 {
  width: 100%;
  /*&.p-buttonset{
      display: flex;
      .p-button{
          flex-grow:1;
      }
  }*/
}
.editNoteContent .windowBottomControls {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}
.editNoteContent .windowBottomControls ::ng-deep .p-element {
  flex-grow: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/cp/shared/components/add-note/add-note.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,SAAA;AACJ;AAAI;EACI,WAAA;EACA;;;;;IAAA;AAOR;AAAI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAER;AADQ;EACI,YAAA;AAGZ","sourcesContent":[".editNoteContent{\n    display: grid;\n    gap: 1rem;\n    ::ng-deep .wid100{\n        width:100%;\n        /*&.p-buttonset{\n            display: flex;\n            .p-button{\n                flex-grow:1;\n            }\n        }*/\n    }\n    .windowBottomControls{\n        display:flex;\n        flex-direction:row;\n        gap:1rem;\n        ::ng-deep .p-element {\n            flex-grow:1;\n            //.p-button{width:100%;}\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
